import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { TeamingLogMessages } from 'features/teaming/teaming-base/enums';

export const requestHandoffAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: TeamingLogMessages.HANDOFF_BUTTON_CLICKED,
  });
};
